module.exports = __webpack_public_path__ + "../resources/images/illustration_moon_error-7ab6971dc293fd693ae4aaab948b19f4.svg";